import { IOrderPaginatedListData } from '@/services/order';
import {
  IFetchOrderActionPayload,
  IOrderActions,
  OrderContext
} from './actions.types';
import { IOrderData } from '@/models';

export const actions: IOrderActions = {
  fetchOrders(
    context: OrderContext,
    payload: IFetchOrderActionPayload
  ): Promise<void> {
    const promise = this.$services.order.fetchOrders(payload);
    context.commit('SET_LAST_PROMISE', promise);

    return promise.then((orders: IOrderPaginatedListData) => {
      if (promise == context.state.lastPromise) {
        context.commit('SET_ORDERS', orders.results);
        context.commit('SET_COUNT', orders.count);
        context.commit('SET_LAST_PROMISE', null);
      }
    });
  },

  fetchOrder(context: OrderContext, payload: string): Promise<void> {
    return this.$services.order
      .fetchOrder(payload)
      .then((order: IOrderData) => {
        const index = context.state.orders.findIndex(
          (v: IOrderData) => v.series === order.series
        );
        if (index === -1) {
          context.commit('ADD_ORDER', order);
          context.commit('INCREMENT_COUNT');
        } else {
          context.commit('UPDATE_ORDER', order);
        }
      });
  },

  createOrder(context: OrderContext, payload: IOrderData): Promise<void> {
    return this.$services.order
      .createOrder(payload)
      .then((order: IOrderData) => {
        context.commit('ADD_ORDER', order);
        context.commit('INCREMENT_COUNT');
      });
  },

  updateOrder(context: OrderContext, payload: IOrderData): Promise<void> {
    return this.$services.order
      .updateOrder(payload)
      .then((order: IOrderData) => {
        const index = context.state.orders.findIndex(
          (v: IOrderData) => v.series === order.series
        );
        if (index === -1) {
          context.commit('ADD_ORDER', order);
          context.commit('INCREMENT_COUNT');
        } else {
          context.commit('UPDATE_ORDER', order);
        }
      });
  },

  deleteOrder(context: OrderContext, payload: string): Promise<void> {
    return this.$services.order.deleteOrder(payload).then(() => {
      context.commit('REMOVE_ORDER', payload);
      context.commit('DECREMENT_COUNT');
    });
  },

  exportOrderPriceDistribution(
    _context: OrderContext,
    payload: string
  ): Promise<Blob> {
    return this.$services.order.exportOrderPriceDistribution(payload);
  }
};
